import { ATTRS, PRODUCT_TYPES, TAGS } from '../constants';
import { EntitiesManager } from '../entitiesManager';
import { Entity } from '../types';
import { ProductEntity } from './Product';
import { ValuePresentationEntity } from './ValuePresentation';

export class ProcessDataVariableEntity implements Entity {
  public static fromXML(xml, matchIDs, files, entitiesManager: EntitiesManager) {
    const attrs = xml._attributes;
    const valuePresentation = entitiesManager.getEntityByIsoId<ValuePresentationEntity>(
      attrs[ATTRS.ProcessDataVariable.ValuePresentationIdRef]
    );
    const product = entitiesManager.getEntityByIsoId<ProductEntity>(
      attrs[ATTRS.ProcessDataVariable.ProductIdRef]
    );

    const childPDVs = (attrs[TAGS.ProcessDataVariable] || []).map((xml) =>
      ProcessDataVariableEntity.fromXML(xml, matchIDs, files, entitiesManager)
    );

    return {
      entity: new ProcessDataVariableEntity(
        attrs[ATTRS.ProcessDataVariable.ProcessDataDDI],
        +attrs[ATTRS.ProcessDataVariable.ProcessDataValue],
        valuePresentation,
        product,
        childPDVs
      ),
    };
  }
  public type = TAGS.ProcessDataVariable;

  constructor(
    private DDI: string,
    private value: number,
    private valuePresentation?: ValuePresentationEntity,
    private product?: ProductEntity,
    private childProcessDataVariables?: ProcessDataVariableEntity[]
  ) {}

  public toXML(xmlId: string, entityManager: EntitiesManager) {
    const presentationIsoId = entityManager.registerEntity(this.valuePresentation);
    const productIsoId = entityManager.registerEntity(this.product);
    let childPDVs = this.childProcessDataVariables || [];

    // we use child PDVs to emulate product mix for ISOXML v3
    if (entityManager.options.version === 3 && this.product.productType === PRODUCT_TYPES.Mixture) {
      const scale = this.value / this.product.mixtureRecipeQuantity;
      childPDVs = [
        ...childPDVs,
        ...this.product.productRelations.map(
          (rel) =>
            new ProcessDataVariableEntity(
              rel.product.quantityDDI,
              rel.quantityValue * scale,
              this.valuePresentation,
              rel.product
            )
        ),
      ];
    }

    return {
      _attributes: {
        [ATTRS.ProcessDataVariable.ProcessDataDDI]: this.DDI,
        [ATTRS.ProcessDataVariable.ProcessDataValue]: this.value,
        ...(presentationIsoId && {
          [ATTRS.ProcessDataVariable.ValuePresentationIdRef]: presentationIsoId,
        }),
        ...(productIsoId && { [ATTRS.ProcessDataVariable.ProductIdRef]: productIsoId }),
      },
      [TAGS.ProcessDataVariable]: (childPDVs || []).map((pdv) => pdv.toXML(null, entityManager)),
    };
  }

  public cloneWithZeroValue() {
    return new ProcessDataVariableEntity(
      this.DDI,
      0,
      this.valuePresentation,
      this.product,
      this.childProcessDataVariables
    );
  }
}
